"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.userActivityFormatter = exports.UserActivityActionType = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var ui_common_1 = require("@codametrix/ui-common");
var case_hold_1 = require("../case-hold/case-hold");
var DocumentStatus = ui_common_1.commonEnums.DocumentStatus, HoldReasonType = ui_common_1.commonEnums.HoldReasonType;
var UserActivityActionType;
(function (UserActivityActionType) {
    UserActivityActionType["UPDATE_CODE"] = "UPDATE_CODE";
    UserActivityActionType["REMOVE_CODE"] = "REMOVE_CODE";
    UserActivityActionType["ADD_CODE"] = "ADD_CODE";
    UserActivityActionType["SUBMIT_CODES"] = "SUBMIT_CODES";
    UserActivityActionType["CANCEL_CASE"] = "CANCEL_CASE";
    UserActivityActionType["ADD_INVOICE"] = "ADD_INVOICE";
    UserActivityActionType["UPDATE_INVOICE"] = "UPDATE_INVOICE";
    UserActivityActionType["DELETE_INVOICE"] = "DELETE_INVOICE";
    UserActivityActionType["ADD_TRANSACTION"] = "ADD_TRANSACTION";
    UserActivityActionType["DELETE_TRANSACTION"] = "DELETE_TRANSACTION";
    UserActivityActionType["UPDATE_CHARGEABLE"] = "UPDATE_CHARGEABLE";
    UserActivityActionType["ADD_DOCUMENT_IMPROVEMENT"] = "ADD_DOCUMENT_IMPROVEMENT";
    UserActivityActionType["UPDATE_DOCUMENT_IMPROVEMENT"] = "UPDATE_DOCUMENT_IMPROVEMENT";
    UserActivityActionType["DELETE_DOCUMENT_IMPROVEMENT"] = "DELETE_DOCUMENT_IMPROVEMENT";
    UserActivityActionType["ADD_PROVIDER"] = "ADD_PROVIDER";
    UserActivityActionType["UPDATE_PROVIDER"] = "UPDATE_PROVIDER";
    UserActivityActionType["DELETE_PROVIDER"] = "DELETE_PROVIDER";
    UserActivityActionType["HOLD_PROCESS_INSTANCE"] = "HOLD_PROCESS_INSTANCE";
    UserActivityActionType["UPDATE_FIELD"] = "UPDATE_FIELD";
    UserActivityActionType["SPLIT_CASE"] = "SPLIT_CASE";
    UserActivityActionType["MERGE_CASE"] = "MERGE_CASE";
    UserActivityActionType["CREATE_CASE"] = "CREATE_CASE";
    UserActivityActionType["MANUAL_ASSIGNMENT"] = "MANUAL_ASSIGNMENT";
    UserActivityActionType["REFRESH_CASE"] = "REFRESH_CASE";
})(UserActivityActionType = exports.UserActivityActionType || (exports.UserActivityActionType = {}));
var invoiceChangeRepr = function (activity) {
    if (!activity.updatedInvoiceFieldName) {
        return '';
    }
    else {
        return (activity.updatedInvoiceFieldName
            // insert a space before all caps
            .replace(/([A-Z])/g, ' $1')
            .toLowerCase());
    }
};
var ActivityCodeType;
(function (ActivityCodeType) {
    ActivityCodeType["PROCEDURE"] = "ProcedureCode";
    ActivityCodeType["DIAGNOSIS"] = "DiagnosisCode";
    ActivityCodeType["MODIFIER"] = "ModifierCode";
})(ActivityCodeType || (ActivityCodeType = {}));
var codeRepr = function (activity) {
    if (activity.codeType === ActivityCodeType.PROCEDURE) {
        return "procedure";
    }
    else if (activity.codeType === ActivityCodeType.DIAGNOSIS) {
        return "diagnosis";
    }
    else if (activity.codeType === ActivityCodeType.MODIFIER) {
        return "modifier";
    }
};
var userActivityFormatter = function (activity) {
    var _a, _b, _c;
    var inner;
    if (activity.actionType === UserActivityActionType.ADD_CODE) {
        inner = ((0, jsx_runtime_1.jsxs)("span", __assign({ className: "activity-readout" }, { children: [activity.username, " added the ", (0, jsx_runtime_1.jsx)("b", { children: activity.code }), ' ', codeRepr(activity), "."] })));
    }
    else if (activity.actionType === UserActivityActionType.REMOVE_CODE) {
        inner = ((0, jsx_runtime_1.jsxs)("span", __assign({ className: "activity-readout" }, { children: [activity.username, " removed the ", (0, jsx_runtime_1.jsx)("b", { children: activity.code }), ' ', codeRepr(activity), "."] })));
    }
    else if (activity.actionType === UserActivityActionType.UPDATE_CODE) {
        if (activity.codeType === ActivityCodeType.DIAGNOSIS ||
            activity.codeType === ActivityCodeType.MODIFIER) {
            inner = ((0, jsx_runtime_1.jsxs)("span", __assign({ className: "activity-readout qa-updated-moved" }, { children: [activity.username, " updated the ", (0, jsx_runtime_1.jsx)("b", { children: activity.code }), ' ', codeRepr(activity), " to ", (0, jsx_runtime_1.jsx)("b", { children: "a different order" }), "."] })));
        }
        else {
            inner = ((0, jsx_runtime_1.jsxs)("span", __assign({ className: "activity-readout qa-changed-units" }, { children: [activity.username, " updated the ", (0, jsx_runtime_1.jsx)("b", { children: activity.code }), ' ', codeRepr(activity), " to ", (0, jsx_runtime_1.jsxs)("b", { children: [activity.units, " units"] }), "."] })));
        }
    }
    else if (activity.actionType === UserActivityActionType.SUBMIT_CODES) {
        if (activity.withOverride) {
            inner = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("span", __assign({ className: "activity-readout" }, { children: [activity.username, " submitted the charges with an override."] })), (0, jsx_runtime_1.jsx)("span", __assign({ className: "activity-message" }, { children: activity.message }))] }));
        }
        else {
            inner = ((0, jsx_runtime_1.jsxs)("span", __assign({ className: "activity-readout" }, { children: [activity.username, " submitted the charges."] })));
        }
    }
    else if (activity.actionType === UserActivityActionType.REFRESH_CASE) {
        inner = ((0, jsx_runtime_1.jsxs)("span", __assign({ className: "activity-readout" }, { children: [activity.username, " refreshed the case."] })));
    }
    else if (activity.actionType === UserActivityActionType.CANCEL_CASE) {
        inner = ((0, jsx_runtime_1.jsxs)("span", __assign({ className: "activity-readout" }, { children: [activity.username, " cancelled the case."] })));
    }
    else if (activity.actionType === UserActivityActionType.ADD_INVOICE) {
        inner = ((0, jsx_runtime_1.jsxs)("span", __assign({ className: "activity-readout" }, { children: [activity.username, " added an invoice."] })));
    }
    else if (activity.actionType === UserActivityActionType.DELETE_INVOICE) {
        inner = ((0, jsx_runtime_1.jsxs)("span", __assign({ className: "activity-readout" }, { children: [activity.username, " removed an invoice."] })));
    }
    else if (activity.actionType === UserActivityActionType.UPDATE_INVOICE) {
        inner = ((0, jsx_runtime_1.jsxs)("span", __assign({ className: "activity-readout" }, { children: [activity.username, " updated an invoice with", ' ', invoiceChangeRepr(activity), " to", ' ', (0, jsx_runtime_1.jsxs)("b", { children: [activity.updatedInvoiceFieldValue, "."] })] })));
    }
    else if (activity.actionType === UserActivityActionType.ADD_TRANSACTION) {
        inner = ((0, jsx_runtime_1.jsxs)("span", __assign({ className: "activity-readout" }, { children: [activity.username, " added a charge."] })));
    }
    else if (activity.actionType === UserActivityActionType.DELETE_TRANSACTION) {
        inner = ((0, jsx_runtime_1.jsxs)("span", __assign({ className: "activity-readout" }, { children: [activity.username, " removed a charge."] })));
    }
    else if (activity.actionType === UserActivityActionType.UPDATE_CHARGEABLE) {
        inner = ((0, jsx_runtime_1.jsxs)("span", __assign({ className: "activity-readout" }, { children: [activity.username, " made this case", ' ', "".concat((activity === null || activity === void 0 ? void 0 : activity.isChargeable) ? 'chargeable' : 'non-chargeable'), "."] })));
    }
    else if (activity.actionType === UserActivityActionType.ADD_DOCUMENT_IMPROVEMENT) {
        inner = ((0, jsx_runtime_1.jsxs)("span", __assign({ className: "activity-readout" }, { children: [activity.username, " added ", (0, jsx_runtime_1.jsx)("b", { children: activity.documentImprovement }), ' ', "improvement."] })));
    }
    else if (activity.actionType === UserActivityActionType.UPDATE_DOCUMENT_IMPROVEMENT) {
        var fieldName = activity === null || activity === void 0 ? void 0 : activity.updatedDocumentImprovementFieldName;
        var fieldValue = activity === null || activity === void 0 ? void 0 : activity.updatedDocumentImprovementFieldValue;
        var filedText = fieldName === 'charge_code' ? 'charge code' : 'potential charge code';
        var activityType = fieldValue ? ' added' : 'removed';
        var actionDetail = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [activityType, " ", (0, jsx_runtime_1.jsx)("b", { children: fieldValue }), " ", filedText, ' ', fieldValue ? 'to' : 'from'] }));
        inner = ((0, jsx_runtime_1.jsxs)("span", __assign({ className: "activity-readout" }, { children: [activity.username, " ", actionDetail, " ", (0, jsx_runtime_1.jsx)("b", { children: activity.documentImprovement }), ' ', "improvement."] })));
    }
    else if (activity.actionType === UserActivityActionType.DELETE_DOCUMENT_IMPROVEMENT) {
        inner = ((0, jsx_runtime_1.jsxs)("span", __assign({ className: "activity-readout" }, { children: [activity.username, " deleted ", (0, jsx_runtime_1.jsx)("b", { children: activity.documentImprovement }), ' ', "improvement."] })));
    }
    else if (activity.actionType === UserActivityActionType.ADD_PROVIDER) {
        inner = ((0, jsx_runtime_1.jsxs)("span", __assign({ className: "activity-readout" }, { children: [activity.username, " added provider", ' ', (0, jsx_runtime_1.jsx)("b", { children: ui_common_1.objectUtils.capitalize(activity.documentImprovementProviderName) }), ' ', "to ", (0, jsx_runtime_1.jsx)("b", { children: activity.documentImprovement }), " improvement."] })));
    }
    else if (activity.actionType === UserActivityActionType.DELETE_PROVIDER) {
        inner = ((0, jsx_runtime_1.jsxs)("span", __assign({ className: "activity-readout" }, { children: [activity.username, " removed provider", ' ', (0, jsx_runtime_1.jsx)("b", { children: ui_common_1.objectUtils.capitalize(activity.documentImprovementProviderName) }), ' ', "from ", (0, jsx_runtime_1.jsx)("b", { children: activity.documentImprovement }), " improvement."] })));
    }
    else if (activity.actionType === UserActivityActionType.UPDATE_PROVIDER) {
        inner = ((0, jsx_runtime_1.jsxs)("span", __assign({ className: "activity-readout" }, { children: [activity.username, " updated provider", ' ', (0, jsx_runtime_1.jsx)("b", { children: ui_common_1.objectUtils.capitalize(activity.documentImprovementProviderName) }), ' ', "with status", ' ', (0, jsx_runtime_1.jsx)("b", { children: ui_common_1.objectUtils.capitalize((_a = activity.documentImprovementProviderQueryStatus) === null || _a === void 0 ? void 0 : _a.replace(/_/g, ' ')) }), ' ', "for ", (0, jsx_runtime_1.jsx)("b", { children: activity.documentImprovement }), " improvement."] })));
    }
    else if (activity.actionType === UserActivityActionType.HOLD_PROCESS_INSTANCE) {
        var hasComment = false;
        if (activity.message !== '' &&
            activity.message !== null &&
            activity.message !== undefined) {
            hasComment = true;
        }
        var holdDetail = "".concat(activity.username, " ").concat(activity.holdReason === HoldReasonType.OFF_HOLD
            ? 'took the case '
            : 'has put the case on ');
        var holdReason = "".concat(activity.holdReason === HoldReasonType.OFF_HOLD
            ? 'off hold'
            : case_hold_1.HoldReasonLabel[activity.holdReason]);
        inner = ((0, jsx_runtime_1.jsxs)("span", __assign({ className: "activity-readout" }, { children: [holdDetail, (0, jsx_runtime_1.jsx)("b", { children: holdReason }), hasComment && ((0, jsx_runtime_1.jsxs)("span", { children: [(0, jsx_runtime_1.jsx)("br", {}), " and added comment ", (0, jsx_runtime_1.jsx)("b", { children: activity.message })] }))] })));
    }
    else if (activity.actionType === UserActivityActionType.UPDATE_FIELD) {
        var fieldName = (_b = activity.updatedFieldName) === null || _b === void 0 ? void 0 : _b.toUpperCase().split('_').join(' ');
        var fieldValue = (_c = activity.updatedFieldValue) === null || _c === void 0 ? void 0 : _c.toUpperCase().split('_').join(' ');
        inner = ((0, jsx_runtime_1.jsxs)("span", __assign({ className: "activity-readout" }, { children: [activity.username, " updated the value of ", (0, jsx_runtime_1.jsxs)("b", { children: [fieldName, " "] }), "to ", (0, jsx_runtime_1.jsx)("b", { children: fieldValue }), "."] })));
    }
    else if (activity.actionType === UserActivityActionType.SPLIT_CASE) {
        inner = ((0, jsx_runtime_1.jsxs)("span", __assign({ className: "activity-readout" }, { children: [activity.username, " performed split."] })));
    }
    else if (activity.actionType === UserActivityActionType.MERGE_CASE) {
        inner = ((0, jsx_runtime_1.jsxs)("span", __assign({ className: "activity-readout" }, { children: [activity.username, " performed merge."] })));
    }
    else if (activity.actionType === UserActivityActionType.CREATE_CASE) {
        var hasComment = !!activity.message;
        inner = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("span", __assign({ className: "activity-readout" }, { children: [activity.username, " created the case"] })), hasComment && ((0, jsx_runtime_1.jsxs)("span", { children: [(0, jsx_runtime_1.jsx)("br", {}), " and added comment ", (0, jsx_runtime_1.jsxs)("b", { children: [activity.message, "."] })] }))] }));
    }
    else if (activity.actionType === UserActivityActionType.MANUAL_ASSIGNMENT) {
        inner = ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)("span", __assign({ className: "activity-readout" }, { children: [activity.username, " reasssigned the case to", ' ', activity.reassignedUsername, "."] })) }));
    }
    return ((0, jsx_runtime_1.jsxs)("span", __assign({ className: "activity-item" }, { children: [inner, (0, jsx_runtime_1.jsx)("span", __assign({ className: "activity-timestamp" }, { children: activity.timestamp
                    ? ui_common_1.cmxDateTime.format(activity.timestamp, ui_common_1.cmxDateTime.FORMATS.LONG_DATE_TIME)
                    : 'N/A' }))] })));
};
exports.userActivityFormatter = userActivityFormatter;
//# sourceMappingURL=useractivity-timeline-formatter.js.map